import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './home.css';
import './home-chatdesk.css';

/* ---- Inline icons (no external assets) ---- */
const Icon = {
  spark: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 3l2.2 5.3L20 10.5l-5.8 2.2L12 18l-2.2-5.3L4 10.5l5.8-2.2z" />
    </svg>
  ),
  check: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),
  checkCircle: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="12" cy="12" r="9" /><path d="M8.5 12.5l2.4 2.4 4.6-5" />
    </svg>
  ),
  shield: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 3l7 3v6c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z" /><path d="M9 12l2 2 4-4" />
    </svg>
  ),
  bolt: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M13 2L4 14h7l-1 8 9-12h-7z" />
    </svg>
  ),
  doc: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /><path d="M9 13h6M9 17h6" />
    </svg>
  ),
  send: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M22 2L11 13" /><path d="M22 2l-7 20-4-9-9-4z" />
    </svg>
  ),
  cpu: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="7" y="7" width="10" height="10" rx="2" /><path d="M10 10h4v4h-4z" />
      <path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" />
    </svg>
  ),
  search: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="11" cy="11" r="7" /><path d="M21 21l-4-4" />
    </svg>
  ),
  code: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M8 8l-4 4 4 4M16 8l4 4-4 4M13 6l-2 12" />
    </svg>
  ),
  key: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="8" cy="8" r="4" /><path d="M11 11l9 9" /><path d="M16 16l2-2M19 19l2-2" />
    </svg>
  ),
  chart: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </svg>
  ),
  building: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16" /><path d="M14 9h4a2 2 0 0 1 2 2v10" /><path d="M3 21h18M7 7h2M7 11h2M7 15h2" />
    </svg>
  ),
  users: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="9" cy="8" r="3.5" /><path d="M3 20a6 6 0 0 1 12 0" /><path d="M16 5.5a3.5 3.5 0 0 1 0 6.8M22 20a6 6 0 0 0-5-5.9" />
    </svg>
  ),
  briefcase: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18" />
    </svg>
  ),
  user: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" />
    </svg>
  ),
  chat: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21 12a8 8 0 0 1-11.4 7.2L3 21l1.8-6.6A8 8 0 1 1 21 12z" />
    </svg>
  ),
  layers: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 3l9 5-9 5-9-5 9-5z" /><path d="M3 13l9 5 9-5M3 18l9 5 9-5" />
    </svg>
  ),
  arrow: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
  book: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
};

const DEMO_HREF = 'mailto:sales@cerebralmachines.ai?subject=Denial%20Chat%20Desk%20Demo';

const PROBLEM_QS = [
  'What does this CARC/RARC combination really mean?',
  'Is the CPT payable with the submitted diagnosis?',
  'Does this payer policy require prior authorization?',
  'Is this a coding, medical necessity, documentation, or payment issue?',
  'Which LCD, NCD, Article, or coding rule applies?',
  'What documentation is needed to support an appeal?',
  'Should this be appealed, corrected, billed differently, or written off?',
];

const COVERAGE = [
  'CARC and RARC interpretation',
  'NCCI procedure-to-procedure edits',
  'MUE unit limits',
  'ICD-10-CM diagnosis validation',
  'CPT / HCPCS reference support',
  'Medicare LCD, NCD & Article logic',
  'Covered & non-covered diagnosis checks',
  'Payer-specific policy review',
  'Prior authorization requirements',
  'Place-of-service rules',
  'Documentation requirements',
  'Timely filing & corrected claims',
  'Duplicate claim & COB logic',
  'Modifier, bundling & global-period',
  'Payment variance & underpayment',
];

const CAPABILITIES = [
  {
    icon: Icon.chat,
    title: 'Ask in plain English',
    text: 'No need to know which table, policy, or graph to search first. Ask a natural question and get a structured answer.',
    example: 'UHC denied CPT 77065 for medical necessity. The chart shows a palpable breast lump and abnormal prior imaging. Is this appealable?',
  },
  {
    icon: Icon.search,
    title: 'Decode denial reason codes',
    text: 'Turn confusing payer remittance codes into operational meaning and a clear first step.',
    example: 'What does CARC 50 with RARC N115 mean, and what should we check first?',
  },
  {
    icon: Icon.code,
    title: 'Validate coding & policy logic',
    text: 'Research coding edits, diagnosis compatibility, procedure rules, and payer requirements.',
    example: 'Is this an NCCI edit, MUE limit, diagnosis coverage, modifier, or place-of-service issue?',
  },
  {
    icon: Icon.doc,
    title: 'Identify missing documentation',
    text: 'Know exactly what chart evidence is needed before you file an appeal.',
    example: 'What documentation do we need to support a denied diagnostic mammogram?',
  },
  {
    icon: Icon.checkCircle,
    title: 'Determine next-best action',
    text: 'Decide whether to appeal, correct and resubmit, request records, rebill, route to coding, or accept.',
    example: 'Should this denial be appealed or corrected?',
  },
  {
    icon: Icon.send,
    title: 'Draft appeal-ready reasoning',
    text: 'Generate structured appeal rationale grounded in the clinical, coding, and policy basis.',
    example: 'Draft a first-level appeal argument based on the chart evidence and coverage criteria.',
  },
];

const KNOWLEDGE = [
  'CMS & payer policy references',
  'Medicare Coverage Database content',
  'LCD, NCD & Article narratives',
  'Covered / non-covered ICD-10 relationships',
  'CPT / HCPCS references',
  'NCCI policy & procedure edit data',
  'MUE data',
  'ICD-10-CM & ICD-10-PCS guidance',
  'CARC / RARC interpretation',
  'Payer-specific denial mappings',
  'Evidence requirement checklists',
  'Appeal deadline & routing rules',
  'Historical denial pattern intelligence',
];

const EXPERTISE = [
  'Intake & identity',
  'Eligibility & coverage',
  'Prior authorization',
  'Medical necessity',
  'Coding, NCCI, MUE & modifiers',
  'Documentation',
  'Duplicate & timely filing',
  'Coordination of benefits & MSP',
  'Credentialing & network',
  'Payment variance & underpayment',
  'Specialty-specific denials',
  'Front-end rejection repair',
];

const AUTOMATION = [
  'Denial family classification',
  'Coding denial workup',
  'NCCI & MUE validation',
  'Medical necessity evidence review',
  'Payer policy matching',
  'Appealability scoring',
  'Expected recovery estimation',
  'Next-action recommendation',
  'Appeal-ready summary generation',
  'Human review routing on low confidence',
];

const AUDIENCES = [
  { icon: Icon.user, title: 'Billers', points: ['Understand denial codes in seconds', 'Know the right next step', 'Skip the manual portal hunting'] },
  { icon: Icon.code, title: 'Coders', points: ['Validate CPT, ICD-10 & modifiers', 'Check NCCI and MUE issues', 'Confirm bundling and edits fast'] },
  { icon: Icon.doc, title: 'Denial specialists', points: ['Prepare appeal rationale', 'Build evidence checklists', 'Cite the policy that supports it'] },
  { icon: Icon.users, title: 'Supervisors', points: ['Standardize how denials are worked', 'Keep decisions consistent', 'Onboard new staff faster'] },
  { icon: Icon.chart, title: 'RCM leaders', points: ['Cut research time across teams', 'Scale denial knowledge', 'Build a repeatable operation'] },
];

const HOW = [
  { icon: Icon.chat, title: 'Ask a denial question', text: 'Enter a denial scenario, claim line, CPT, diagnosis, payer, CARC/RARC, or chart summary.' },
  { icon: Icon.search, title: 'It searches denial intelligence', text: 'Checks structured lookups, payer references, coding rules, medical necessity sources, and policy graphs.' },
  { icon: Icon.book, title: 'Get a grounded answer', text: 'Explains the denial, identifies the rule, lists missing evidence, and recommends the next action.' },
  { icon: Icon.arrow, title: 'Move from answer to action', text: 'Route the case, correct the claim, request records, draft appeal rationale, or escalate for review.' },
];

const EXAMPLE_QS = [
  'Why did this claim deny?',
  'What does this CARC/RARC combination mean?',
  'Is this CPT covered for this diagnosis?',
  'Which diagnosis codes support this procedure?',
  'Does this payer require prior authorization?',
  'Is this a coding denial or a medical necessity denial?',
  'What evidence do we need for appeal?',
  'Is this denial appealable?',
  'What is the strongest appeal argument?',
  'Does NCCI allow these two CPTs together?',
  'Is a modifier appropriate here?',
  'Did this exceed MUE limits?',
  'Does the place of service look valid?',
  'What should the denial specialist do next?',
];

const BENEFITS = [
  { icon: Icon.bolt, title: 'Faster denial research', text: 'Cut the time spent searching across payer policies, CMS references, coding rules, and internal notes.' },
  { icon: Icon.checkCircle, title: 'More consistent decisions', text: 'Standardize denial interpretation and next-action guidance across your whole team.' },
  { icon: Icon.doc, title: 'Better appeal readiness', text: 'Identify the evidence, policy basis, and documentation needed before filing.' },
  { icon: Icon.code, title: 'Coding & medical necessity support', text: 'Connect denial work to CPT, ICD-10, NCCI, MUE, LCD, NCD, Article, and payer policy logic.' },
  { icon: Icon.shield, title: 'Human-controlled automation', text: 'Start with chat support, then selectively automate high-confidence coding and medical necessity denials.' },
  { icon: Icon.layers, title: 'Scalable denial knowledge', text: 'Convert scattered denial expertise into an accessible support desk for the whole RCM operation.' },
];

export default function HomePageChatDesk() {
  useEffect(() => {
    document.title = 'Denial Chat Desk - AI denial support for RCM teams · CerebralMachines.ai';
  }, []);

  return (
    <div className="home">
      {/* Header */}
      <header className="home-header">
        <div className="home__wrap home-header__inner">
          <Link to="/chatdesk" className="home-brand" aria-label="Denial Chat Desk by CerebralMachines.ai">
            <img
              src={`${process.env.PUBLIC_URL || ''}/rcmboost-logo-light.png`}
              alt="Denial Chat Desk — by CerebralMachines.ai"
              className="home-brand__img"
            />
          </Link>
          <nav className="home-nav">
            <a href="#how">How it works</a>
            <a href="#answers">What it answers</a>
            <a href="#who">Who it&apos;s for</a>
            <a href="#examples">Examples</a>
          </nav>
          <div className="home-header__actions">
            <Link to="/login" className="home-link">Sign in</Link>
            <a href={DEMO_HREF} className="home-btn home-btn--primary">Request a Demo</a>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="home-hero">
        <div className="home__wrap home-hero__inner">
          <div className="home-hero__copy">
            <span className="home-eyebrow"><span className="dot" /> AI-powered denial support for RCM teams</span>
            <h1>Get denial answers<br /><span className="grad">instantly.</span></h1>
            <p className="home-hero__sub">
              Across payer policies, coding rules, medical necessity criteria, appeal requirements,
              and claim-level evidence. Instead of searching policy PDFs, LCDs, NCCI edits, and
              CARC/RARC codes, your team asks a question in plain English and gets a grounded,
              case-aware answer.
            </p>
            <div className="home-hero__cta">
              <a href={DEMO_HREF} className="home-btn home-btn--primary home-btn--lg">Request a Demo <Icon.arrow /></a>
              <a href="#answers" className="home-btn home-btn--ghost home-btn--lg">See what it can answer</a>
            </div>
            <div className="home-hero__trust">
              <span className="home-trust-item"><Icon.check /> Grounded, source-cited answers</span>
              <span className="home-trust-item"><Icon.check /> Case-aware reasoning</span>
              <span className="home-trust-item"><Icon.check /> Built for real RCM work</span>
            </div>
          </div>

          <div className="home-hero__visual">
            <div className="home-mock">
              <div className="home-mock__bar">
                <span className="home-mock__dot" /><span className="home-mock__dot" /><span className="home-mock__dot" />
                <span className="home-mock__title">Denial Chat Desk · DENIAL-2026-000217</span>
              </div>
              <div className="cd-chat">
                <div className="cd-msg cd-msg--user">
                  <span className="cd-msg__avatar cd-msg__avatar--user"><Icon.user /></span>
                  <div className="cd-bubble cd-bubble--user">
                    UHC denied CPT 77065 for medical necessity. The claim had a nonspecific diagnosis,
                    but the chart shows a palpable breast lump and abnormal prior imaging. Is this appealable?
                  </div>
                </div>
                <div className="cd-msg cd-msg--bot">
                  <span className="cd-msg__avatar cd-msg__avatar--bot"><Icon.spark /></span>
                  <div className="cd-bubble cd-bubble--bot">
                    <div className="cd-answer__line"><span className="cd-tag cd-tag--cat">Medical necessity</span> Likely appealable.</div>
                    <div className="cd-answer__rows">
                      <div className="cd-answer__row"><span className="cd-answer__k">Rule</span><span className="cd-answer__v">Diagnosis on claim did not meet LCD coverage criteria</span></div>
                      <div className="cd-answer__row"><span className="cd-answer__k">Evidence gap</span><span className="cd-answer__v">Submitted dx nonspecific; chart supports R92.8 + palpable lump</span></div>
                      <div className="cd-answer__row"><span className="cd-answer__k">Next action</span><span className="cd-answer__v cd-answer__v--ok">Correct dx &amp; file first-level appeal with chart notes</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-evidence">
                <span className="home-evidence__ic"><Icon.book /></span>
                <div className="home-evidence__body">
                  <span className="home-evidence__label">Source-grounded</span>
                  <span className="home-evidence__text">
                    Based on the <b>UHC diagnostic imaging policy</b> &amp; <b>covered ICD-10 crosswalk</b> — abnormal findings support medical necessity.
                  </span>
                </div>
              </div>
            </div>
            <div className="home-mock__badge">
              <span className="ic"><Icon.checkCircle /></span>
              <span className="tx"><b>Answered</b><span>in seconds, with sources</span></span>
            </div>
          </div>
        </div>
      </section>

      {/* The Problem */}
      <section className="home-section">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">The problem</p>
            <h2>Denial teams are buried in research before they can act</h2>
            <p className="home-section__lede">
              Most denial work doesn&apos;t start with an appeal. It starts with investigation - spread
              across payer portals, policy PDFs, CMS references, coding manuals, claim notes, and tribal
              knowledge. Denial Chat Desk turns that research burden into a guided conversation.
            </p>
          </div>
          <div className="cd-problem">
            {PROBLEM_QS.map((q) => (
              <div className="cd-problem__item" key={q}>
                <span className="cd-problem__q"><Icon.search /></span>
                <span>{q}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why different / coverage */}
      <section className="home-section home-section--tint" id="answers">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Not a generic chatbot</p>
            <h2>A denial operations desk</h2>
            <p className="home-section__lede">
              Purpose-built for the real denial workflow: interpret, classify, validate, research,
              decide, document, and act. It supports denial investigation across every major area.
            </p>
          </div>
          <div className="cd-coverage">
            {COVERAGE.map((c) => (
              <span className="cd-coverage__chip" key={c}><Icon.check /> {c}</span>
            ))}
          </div>
        </div>
      </section>

      {/* What teams can do */}
      <section className="home-section">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">What teams can do</p>
            <h2>From a question to a confident answer</h2>
            <p className="home-section__lede">
              The system responds with a practical denial workup - the likely category, applicable
              rules, evidence gaps, next-best action, and source-grounded reasoning.
            </p>
          </div>
          <div className="home-cards">
            {CAPABILITIES.map((c) => (
              <div className="home-card cd-cap" key={c.title}>
                <div className="home-ic"><c.icon /></div>
                <div className="home-card__name">{c.title}</div>
                <p className="home-card__desc">{c.text}</p>
                <div className="cd-cap__example">
                  <span className="cd-cap__examplelabel"><Icon.chat /> Example</span>
                  <span className="cd-cap__exampletext">{c.example}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Knowledge foundation */}
      <section className="home-section home-section--tint">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Built on denial knowledge, not guesswork</p>
            <h2>Connected to structured lookups, policy graphs &amp; denial expertise</h2>
            <p className="home-section__lede">
              A growing denial intelligence layer grounds every answer in real references and
              specialized expertise - so responses explain the denial, identify the evidence, and
              guide the next action.
            </p>
          </div>
          <div className="cd-knowledge">
            <div className="cd-knowledge__col">
              <h3 className="cd-knowledge__title"><Icon.layers /> Knowledge foundation</h3>
              <div className="cd-tags">
                {KNOWLEDGE.map((k) => <span className="cd-tag-pill" key={k}>{k}</span>)}
              </div>
            </div>
            <div className="cd-knowledge__col">
              <h3 className="cd-knowledge__title"><Icon.shield /> Specialized expertise areas</h3>
              <div className="cd-tags">
                {EXPERTISE.map((e) => <span className="cd-tag-pill cd-tag-pill--alt" key={e}>{e}</span>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Chat to automation */}
      <section className="home-section">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">From chat support to automated resolution</p>
            <h2>Chat is the product. Automation is the evolving engine.</h2>
            <p className="home-section__lede">
              The first priority is a denial support desk your team can trust - teams stay in control
              while the system accelerates research, interpretation, and decision support. Behind it,
              CerebralMachines is building automated case resolution for high-confidence denial types.
            </p>
          </div>
          <div className="home-outcomes">
            <div className="home-outcome home-outcome--light">
              <span className="home-outcome__tag"><Icon.chat /> Primary offering</span>
              <div className="home-outcome__icon"><Icon.chat /></div>
              <h3>Denial Chat Desk</h3>
              <p>A fast, reliable chat-based support desk for working denials. Ask the question, get the rule, the evidence, and the next action - grounded in real denial knowledge.</p>
              <ul>
                <li><Icon.check /> Teams stay fully in control</li>
                <li><Icon.check /> Accelerates research &amp; interpretation</li>
                <li><Icon.check /> Source-grounded, case-aware answers</li>
              </ul>
            </div>
            <div className="home-outcome home-outcome--dark">
              <span className="home-outcome__tag"><Icon.cpu /> Evolving capability</span>
              <div className="home-outcome__icon"><Icon.cpu /></div>
              <h3>Automated denial case resolution</h3>
              <p>A controlled automation layer for high-confidence coding and medical necessity denials - with human review routing wherever confidence isn&apos;t sufficient.</p>
              <ul>
                {AUTOMATION.slice(0, 5).map((a) => <li key={a}><Icon.check /> {a}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Audiences */}
      <section className="home-section home-section--tint" id="who">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Designed for RCM teams</p>
            <h2>Everyone works from the same denial intelligence</h2>
            <p className="home-section__lede">Built for billers, coders, denial specialists, supervisors, and RCM operators.</p>
          </div>
          <div className="cd-audiences">
            {AUDIENCES.map((a) => (
              <div className="home-aud cd-aud" key={a.title}>
                <div className="home-ic"><a.icon /></div>
                <h3>{a.title}</h3>
                <ul>{a.points.map((p) => <li key={p}><Icon.check /> {p}</li>)}</ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="home-section" id="how">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">How it works</p>
            <h2>Ask, search, answer, act</h2>
            <p className="home-section__lede">Four steps from a denial question to a grounded answer you can act on.</p>
          </div>
          <div className="cd-steps">
            {HOW.map((s, i) => (
              <div className="cd-step" key={s.title}>
                <span className="cd-step__num">{i + 1}</span>
                <div className="home-ic"><s.icon /></div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Example questions */}
      <section className="home-section home-section--tint" id="examples">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Example questions</p>
            <h2>Ask it the way your team actually talks</h2>
            <p className="home-section__lede">No special syntax. Just the denial questions you work every day.</p>
          </div>
          <div className="cd-examples">
            {EXAMPLE_QS.map((q) => (
              <span className="cd-examples__chip" key={q}><Icon.chat /> {q}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Key benefits */}
      <section className="home-section">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Key benefits</p>
            <h2>A smarter front desk for denials</h2>
          </div>
          <div className="home-why">
            {BENEFITS.map((b) => (
              <div className="home-why__item" key={b.title}>
                <div className="home-ic"><b.icon /></div>
                <h3>{b.title}</h3>
                <p>{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Closing CTA */}
      <section className="home-cta">
        <div className="home-cta__band">
          <div className="home-cta__inner">
            <div className="home-cta__content">
              <h2>Give your denial team a smarter front desk.</h2>
              <p>Stop forcing RCM teams to search disconnected policies and notes. Answer the question, explain the rule, identify the evidence, guide the next action.</p>
              <a href={DEMO_HREF} className="home-btn home-btn--light home-btn--lg">Request a Demo <Icon.arrow /></a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home__wrap home-footer__inner">
          <div className="home-footer__brand">
            <img
              src={`${process.env.PUBLIC_URL || ''}/rcmboost-logo-light.png`}
              alt="Denial Chat Desk — by CerebralMachines.ai"
              className="home-brand__img home-brand__img--sm"
            />
            <span className="home-footer__copy">
              © {new Date().getFullYear()} CerebralMachines, Inc. All rights reserved.
            </span>
          </div>
          <div className="home-footer__links">
            <Link to="/terms">Terms of Use</Link>
            <Link to="/login">Sign in</Link>
            <a href={DEMO_HREF}>Request a Demo</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
